import { API } from '@/src/api/api'
import { queryKeys } from '@/src/api/queryKeys'
import { ALL_LOCATIONS } from '@/src/contexts/LocationsContext'
import { useQuery } from '@tanstack/react-query'

export const useAtlasTimeSeriesOptions = (locationId: number | undefined, allLocationIds: number[], enabled: boolean) => {
  const isAllLocations = locationId === ALL_LOCATIONS
  let requestedLocationIds: number[] = []
  if (isAllLocations) {
    requestedLocationIds = [...new Set(allLocationIds)].sort((a, b) => a - b)
  } else if (locationId && locationId > 0) {
    requestedLocationIds = [locationId]
  }

  return useQuery({
    queryKey: queryKeys.timeSeries.atlasSelectionOptionsByLocationIds.toKeyWithArgs(requestedLocationIds),
    queryFn: () => {
      if (isAllLocations) return API.timeSeries.fetchAtlasSelectionOptionsForLocations(requestedLocationIds)
      return API.timeSeries.fetchAtlasSelectionOptions(requestedLocationIds[0])
    },
    enabled: enabled && requestedLocationIds.length > 0,
  })
}
